/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react';

/** @module hooks/useEffectOnMount */

/**
 * UseEffect hook only runs when component is mounted
 * @function useEffectOnMount
 * @param {function} callback - Imperative function that can return a cleanup function
 * @returns {void}
 *
 * @memberof module:hooks/useEffectOnMount
 *
 * @example
 * useEffectOnMount(() => {
 *   console.log('mounted');
 *   return () => console.log('unmounted');
 * });
 */
export const useEffectOnMount = (callback) => useEffect(callback, []);
